/**
 * Text Element Editor
 * Uses FormBuilderWithLayout from content-kit - no custom inputs
 */

import * as React from 'react';
import { FormBuilderWithLayout, type FormLayoutConfig } from '@ai-content-hub/content-kit';
import type { ElementEditorProps } from '@ai-content-hub/content-kit';
import { textElementSchema, type TextElementData } from './schema';
import { useElementSchemaLocale } from '../i18n/useElementSchemaLocale';

export interface TextEditProps extends ElementEditorProps<TextElementData> {}

// Layout configuration for text element – flat layout without section titles
const textLayout: FormLayoutConfig = {
    type: 'sections',
    sections: [
        { fields: ['text'] },
        { fields: ['variant', 'alignment'], columns: 2 },
    ],
};

export const TextEdit: React.FC<TextEditProps> = ({
    value,
    onChange,
    errors,
    disabled,
    className,
    config,
    schema: schemaProp,
    language,
}) => {
    const schema = schemaProp ?? textElementSchema;
    const { t } = useElementSchemaLocale(schema.i18n, { config, language });

    const localizedSchema = React.useMemo(() => {
        return {
            ...schema,
            fields: schema.fields.map((field) =>
                field.name === 'text' && field.type === 'text'
                    ? { ...field, placeholder: t('enterText') }
                    : field
            ),
        };
    }, [schema, t]);

    return (
        <FormBuilderWithLayout
            schema={localizedSchema}
            value={value}
            onChange={onChange}
            layout={textLayout}
            errors={errors}
            disabled={disabled}
            className={className}
        />
    );
};

export default TextEdit;
